export const filterLocations = (medicalOrganizations) => (
  medicalOrganizations.map(org => ({
    ...org,
    lng: org.longitude,
    lat: org.latitude
  }))
);